import * as bulkRequestClient from '@modusign/openapi-client-bulk-request/custom-client';
import * as categoryClient from '@modusign/openapi-client-category/custom-client';
import * as documentClient from '@modusign/openapi-client-document/custom-client';
import * as externalDocumentClient from '@modusign/openapi-client-external-document/custom-client';
import * as notificationClient from '@modusign/openapi-client-notification/custom-client';
import * as paymentClient from '@modusign/openapi-client-payment/custom-client';
import * as subscriptionClient from '@modusign/openapi-client-subscription/custom-client';
import * as templateClient from '@modusign/openapi-client-template/custom-client';
import * as userClient from '@modusign/openapi-client-user/custom-client';
import axios from 'axios';

import { paths } from '@app/api/paths';

import * as http401ResponseInterceptor from './axiosInterceptors/401ResponseInterceptor';
import * as errorResponseInterceptor from './axiosInterceptors/errorResponseInterceptor';
import * as linkUser403ResponseInterceptor from './axiosInterceptors/linkUser403ResponseInterceptor';
import * as requestInterceptor from './axiosInterceptors/requestInterceptor';

export function initializeApi() {
  axios.interceptors.response.use(undefined, http401ResponseInterceptor.onRejected);
  axios.interceptors.response.use(undefined, linkUser403ResponseInterceptor.onRejected);
}

export function initializeOpenApiClient() {
  const instances = [
    bulkRequestClient.initializeClient({ baseURL: paths.bulkRequest }),
    categoryClient.initializeClient({ baseURL: paths.category }),
    documentClient.initializeClient({ baseURL: paths.document }),
    externalDocumentClient.initializeClient({ baseURL: paths.externalDocument }),
    notificationClient.initializeClient({ baseURL: paths.notification }),
    paymentClient.initializeClient({ baseURL: paths.payment }),
    subscriptionClient.initializeClient({ baseURL: paths.subscription }),
    templateClient.initializeClient({ baseURL: paths.template }),
    userClient.initializeClient({ baseURL: paths.identityAccess }),
  ];

  instances.forEach((instance) => {
    instance.interceptors.request.use(requestInterceptor.onFulfilled, undefined);
    instance.interceptors.response.use(
      errorResponseInterceptor.onFulfilled,
      errorResponseInterceptor.onRejected
    );
    instance.interceptors.response.use(undefined, http401ResponseInterceptor.onRejected);
    instance.interceptors.response.use(undefined, linkUser403ResponseInterceptor.onRejected);
  });
}
